import { PAGE_MAX_WIDTH } from "src/constants";
import useWindowDimensions from "./useWindowDimensions";

export default function useMobileOrTablet() {
  const window = useWindowDimensions();

  return window.width < PAGE_MAX_WIDTH
}